var nfImage = document.getElementById('nf-image');
if(nfImage) {
    nfImage.addEventListener('change', function () {
        document.getElementById('fileName').textContent = this.files[0].name;
    })
}